import { FC } from 'react'
import classNames from 'classnames/bind'
import { Icon } from '../../../shared'
import { SessionHistoryListItem, getHistoryEventDisplay } from '../LoginHistoryBottomPanel.model'
import { formatFr, toDate } from '../../../../misc/date.utilities'
import { translateKeycloakError } from '../../../../misc/keycloakErrors.utilities'
import styles from './LoginHistoryPanelItem.module.scss'

const cx = classNames.bind(styles)

interface LoginHistoryPanelItemProps {
  item: SessionHistoryListItem
}

export const LoginHistoryPanelItem: FC<LoginHistoryPanelItemProps> = ({ item }) => {
  const display = getHistoryEventDisplay(item)
  const eventDate = toDate(item.time)

  return (
    <div className={cx('item')}>
      <div className={cx('header')}>
        <span className={cx('status', display.statusVariant)}>
          <Icon icon={display.icon} size="nano" color={display.iconColor} />
          {display.label}
        </span>
        <span className={cx('date')}>
          {eventDate ? formatFr(eventDate, 'dd/MM/yyyy à HH:mm') : '-'}
        </span>
      </div>

      <div className={cx('details')}>
        <div className={cx('detailRow')}>
          <span className={cx('detailLabel')}>Adresse IP</span>
          <span className={cx('detailValue')}>{item.ipAddress || '-'}</span>
        </div>

        {display.isError && (
          <div className={cx('detailRow')}>
            <span className={cx('detailLabel')}>Raison</span>
            <span className={cx('detailValue')}>{translateKeycloakError(item.error)}</span>
          </div>
        )}
      </div>
    </div>
  )
}
